export abstract class ViewCreator<View extends object, Arg extends object | null> {
  abstract createView: () => View;
  abstract createViewWithArg: (arg: Arg) => View;
}
